import { ModelGoalFilterInput } from '@akin-home/amplify';
import { useListGoalsQuery } from '@akin-home/goals/frontend';

export * from './subscribeToGoalEvents';

interface Props {
  filter?: ModelGoalFilterInput;
  options?: any;
}

export const useListGoalTemplates = (props?: Props) =>
  useListGoalsQuery(
    {
      filter: {
        isTemplate: { eq: true },
        ...props?.filter,
      },
    },
    props?.options
  );
